/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { FileError } from 'react-dropzone';
import { ExcelRenderer } from 'react-excel-renderer';

/* eslint-disable */
type RowData = {
  [key: string]: any;
};

export const createAgGridData = (rows: RowData) => {
  const colNames: string[] = rows[0];
  const rowData = rows.slice(1);
  const mappedRowData = mapRowData(colNames, rowData);
  return mappedRowData;
};
//eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const mapRowData = (colNames: string[], rowData: RowData) => {
  return rowData.map((row: any[]) => {
    const newRows: any = {};
    row.forEach((item, index) => {
      newRows[colNames[index]] = item;
    });
    return newRows;
  });
};

export const fileHandler = async (file: File): Promise<any> => {
  return await ExcelRenderer(
    file,
    (err: FileError, resp: { rows: any[][]; cols: [] }) => {
      if (!resp || !resp.rows) {
        return undefined;
      }
      if (err) {
        // FIXME: error feedback
        throw new Error(err.message);
      }
      return {
        rows: resp.rows,
      };
    },
  );
};
